import React from "react";
import PropTypes from "prop-types";

const StaticText = ({ label = "", name = "", value = "" }) => {
    return (
        <div>
            <label className="formText w3-text-blue w3-animate-opacity">
                <b>{label}</b>
            </label>
            <div
                className="w3-border w3-round-large"
                name={name}
            >
                {value}
            </div>
        </div>
    );
}

StaticText.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string
};

export default StaticText;
